import { useState } from "react";
import { CircleHelp } from "lucide-react";

import { cn, themeColors } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

import { HelperDrawer } from "../helper-drawer/helper-drawer";

export interface HelperButtonProps {
  className?: string;
}

export function HelperButton({ className }: HelperButtonProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <HelperDrawer
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      trigger={
        <ButtonRebrand
          className={cn("z-50 h-11 w-[86px] gap-2", className)}
          /**
           * Nous utilisons le props style pour garantir le positionnement correct du bouton
           * car les classes Tailwind peuvent être écrasées par les composants parents.
           * Le composant SheetTrigger de Radix UI peut modifier le positionnement des éléments enfants,
           * donc l'utilisation de style inline nous assure que le positionnement sera toujours appliqué.
           */
          style={{ position: "fixed", bottom: "140px", right: "24px" }}
          onClick={() => setIsOpen(true)}
        >
          <CircleHelp color={themeColors["white"]} className="h-4 w-4" />
          {t("component.helper_button.button.label")}
        </ButtonRebrand>
      }
    />
  );
}
